import React from 'react';
import logo from './logo.svg';
import '../App.css';
import Nav from '../components/nav.component';
import Header from '../components/header.component'
import About from '../components/about.component'
import Footer from '../components/footer.component'
import {Row,Col,Container} from 'reactstrap';
import {Table} from "react-bootstrap";
import {Colors} from '../constants/colors'

function boardOfEditorsView() {
    return (
        <div className="BoardOfEditorsView">
            {/*<Nav/>*/}
            <div style={{position:'relative',background:Colors.colorA}} >
                <Row data-aos="fade-up" data-aos-offset="100">
                    <Container style={{paddingLeft: '10%', paddingRight: '10%',marginTop:80, marginBottom:40}}>
                        <div style={{
                            fontSize: 60,
                            fontWeight: 'bold',
                            color: 'white',
                            textAlign:'left'
                            // fontFamily:'Itim',
                        }}>
                            Board of Editors
                        </div>
                    </Container>
                </Row>

            </div>

            <div >
                <Container style={{paddingLeft: '5%', paddingRight: '10%',paddingBottom:80,paddingTop:50}}>
                    <Row
                        data-aos="fade-up"
                         data-aos-offset="100"
                    >
                        <Col md="6" xs="12">
                            {/*<a style={{fontWeight:"bold"}}>Editor in Chief</a>*/}
                            <div style={{fontWeight:"bold", fontSize:22, display:"flex", justifyContent:"center", marginTop:25}}>Editor in Chief</div><br/>
                                <div style={{
                                    fontSize: 18,
                                    textAlign: 'left',
                                    wordSpacing: 3,
                                    padding: 15,
                                    color: 'black',
                                    boxShadow: '0px 0px 6px #000',
                                    borderRadius:15,
                                    justifyContent:"center"

                                    // marginTop:10
                                    // fontFamily:'Itim',
                                }}>
                                    <a style={{fontWeight:"bold"}}>Prof. Pradeep Uluwaduge</a><br/>
                                    Professor<br/>
                                    Department of Social Sciences<br/>
                                    Faculty of Social Sciences and Languages<br/>
                                    Sabaragamuwa University of Sri Lanka<br/>
                                    Email: pradeep@ssl.sab.ac.lk
                                </div>

                        </Col>
                        <Col md="6" xs="12">
                            {/*<a style={{fontWeight:"bold"}}>Editor in Chief</a>*/}
                            <div style={{fontWeight:"bold", fontSize:22, display:"flex", justifyContent:"center", marginTop:25}}>Managing Editor</div><br/>
                            <div style={{fontSize: 18, textAlign: 'left', wordSpacing: 3, padding: 15, color: 'black', boxShadow: '0px 0px 6px #000', borderRadius:15, justifyContent:"center"}}>
                                <a style={{fontWeight:"bold"}}>Prof. Saman Handaragama</a><br/>
                                Professor<br/>
                                Department of Social Sciences<br/>
                                Faculty of Social Sciences and Languages<br/>
                                Sabaragamuwa University of Sri Lanka<br/>
                                Email: saman@ssl.sab.ac.lk
                            </div>
                        </Col>
                    </Row>
                    <Row
                        data-aos="fade-up"
                        data-aos-offset="100"
                    >
                        <div style={{fontWeight:"bold", fontSize:22, display:"flex", justifyContent:"center", marginTop:20, marginBottom:20}}>Editorial Board</div><br/>
                    </Row>
                    <Row
                        data-aos="fade-up"
                        data-aos-offset="100"
                    >
                        <Col md="6" xs="12">
                            <div style={{fontSize: 18, textAlign: 'left', wordSpacing: 3, padding: 15, color: 'black', boxShadow: '0px 0px 6px #000', borderRadius:15, justifyContent:"center", marginBottom:20}}>
                                <a style={{fontWeight:"bold"}}>Prof. Sarath Ananda</a><br/>
                                Professor<br/>
                                Department of Social Sciences<br/>
                                Faculty of Social Sciences and Languages<br/>
                                Sabaragamuwa University of Sri Lanka<br/>
                                Email: sarathananda@ssl.sab.ac.lk
                            </div>
                        </Col>
                        <Col md="6" xs="12">
                            <div style={{fontSize: 18, textAlign: 'left', wordSpacing: 3, padding: 15, color: 'black', boxShadow: '0px 0px 6px #000', borderRadius:15, justifyContent:"center", marginBottom:20}}>
                                <a style={{fontWeight:"bold"}}>Prof. Jayaprasad Welgama</a><br/>
                                Professor<br/>
                                Department of Social Sciences<br/>
                                Faculty of Social Sciences and Languages<br/>
                                Sabaragamuwa University of Sri Lanka<br/>
                                Email: welgama@ssl.sab.ac.lk
                            </div>
                        </Col>
                        <Col md="6" xs="12">
                            <div style={{fontSize: 18, textAlign: 'left', wordSpacing: 3, padding: 15, color: 'black', boxShadow: '0px 0px 6px #000', borderRadius:15, justifyContent:"center", marginBottom:20}}>
                                <a style={{fontWeight:"bold"}}>Dr. GCL Pathirana</a><br/>
                                Assoc. Professor<br/>
                                Department of Social Sciences<br/>
                                Faculty of Social Sciences and Languages<br/>
                                Sabaragamuwa University of Sri Lanka<br/>
                                Email: pathiranaakash@gmail.com
                            </div>
                        </Col>
                        <Col md="6" xs="12">
                            <div style={{fontSize: 18, textAlign: 'left', wordSpacing: 3, padding: 15, color: 'black', boxShadow: '0px 0px 6px #000', borderRadius:15, justifyContent:"center", marginBottom:20}}>
                                <a style={{fontWeight:"bold"}}>Dr. Manjula Wijewickrema</a><br/>
                                Senior Assistant Librarian<br/>
                                Sabaragamuwa University of Sri Lanka<br/>
                                Email: manju@lib.sab.ac.lk
                            </div>
                        </Col>
                        <Col md="6" xs="12">
                            <div style={{fontSize: 18, textAlign: 'left', wordSpacing: 3, padding: 15, color: 'black', boxShadow: '0px 0px 6px #000', borderRadius:15, justifyContent:"center", marginBottom:20}}>
                                <a style={{fontWeight:"bold"}}>Mr. RC Palliyaguruge</a><br/>
                                Senior Lecturer<br/>
                                Department of Social Sciences<br/>
                                Faculty of Social Sciences and Languages<br/>
                                Sabaragamuwa University of Sri Lanka<br/>
                                Email: palliyaguruge@ssl.sab.ac.lk
                            </div>
                        </Col>
                        <Col md="6" xs="12">
                            <div style={{fontSize: 18, textAlign: 'left', wordSpacing: 3, padding: 15, color: 'black', boxShadow: '0px 0px 6px #000', borderRadius:15, justifyContent:"center", marginBottom:20}}>
                                <a style={{fontWeight:"bold"}}>Mr. Aruna Jayathilaka</a><br/>
                                Senior Lecturer<br/>
                                Department of Social Sciences<br/>
                                Faculty of Social Sciences and Languages<br/>
                                Sabaragamuwa University of Sri Lanka<br/>
                                Email: aruna@ssl.sab.ac.lk
                            </div>
                        </Col>
			{/* <Col md="6" xs="12">
                            <div style={{fontSize: 18, textAlign: 'left', wordSpacing: 3, padding: 15, color: 'black', boxShadow: '0px 0px 6px #000', borderRadius:15, justifyContent:"center", marginBottom:20}}>
                                <a style={{fontWeight:"bold"}}>Dr. GCL Pathirana</a><br/>
                                Senior Lecturer<br/>
                                Department of Social Sciences<br/>
                                Faculty of Social Sciences and Languages<br/>
                                Sabaragamuwa University of Sri Lanka<br/>
                                Email: pathiranaakash@gmail.com
                            </div>
                        </Col> */}

                    </Row>

	

                    <Row
                        data-aos="fade-up"
                        data-aos-offset="100"
                    >
                        <div style={{fontWeight:"bold", fontSize:22, display:"flex", justifyContent:"center", marginTop:20, marginBottom:20}}>Editorial Advisory Board</div><br/>
                    </Row>
                    <Row data-aos="fade-up"
                         data-aos-offset="100"
                    >
                       
                        <Col md="6" xs="12">
                            <div style={{fontSize: 18, textAlign: 'left', wordSpacing: 3, padding: 15, color: 'black', boxShadow: '0px 0px 6px #000', borderRadius:15, justifyContent:"center", marginBottom:20}}>
                                <a style={{fontWeight:"bold"}}>Prof Emeritus Kamala Liyanage </a><br/>
                                Emeritus Professor of Political Science<br/>
                                Department of Political Science<br/>
                                Faculty of Arts<br/>
                                University of Peradeniya<br/>
                                Email: imiyakamala@yahoo.com
                            </div>
                        </Col>
                        <Col md="6" xs="12">
                            <div style={{fontSize: 18, textAlign: 'left', wordSpacing: 3, padding: 15, color: 'black', boxShadow: '0px 0px 6px #000', borderRadius:15, justifyContent:"center", marginBottom:20}}>
                                <a style={{fontWeight:"bold"}}>Senior Prof. Premakumara de Silva</a><br/>
                                Senior Professor of Sociology<br/>
                                Department of Sociology<br/>
                                Faculty of Arts<br/>
                                University of Colombo<br/>
                                Email: prema@soc.cmb.ac.lk
                            </div>
                        </Col>
                        <Col md="6" xs="12">
                            <div style={{fontSize: 18, textAlign: 'left', wordSpacing: 3, padding: 15, color: 'black', boxShadow: '0px 0px 6px #000', borderRadius:15, justifyContent:"center", marginBottom:20}}>
                                <a style={{fontWeight:"bold"}}>Prof Zhao Changfeng</a><br/>
                                Chair Professor of International Politics<br/>
                                School of Politics and International Studies<br/>
                                Central China Normal University<br/>
                                Email: zhchf2013@ccnu.edu.cn
                            </div>
                        </Col>
                        <Col md="6" xs="12">
                            <div style={{fontSize: 18, textAlign: 'left', wordSpacing: 3, padding: 15, color: 'black', boxShadow: '0px 0px 6px #000', borderRadius:15, justifyContent:"center", marginBottom:20}}>
                                <a style={{fontWeight:"bold"}}>Prof Kyoko Kusakabe</a><br/>
                                Professor and Chair of Gender and Development Studies<br/>
                                Faculty of Public Policy and Sustainable Development<br/>
                                Asian Institute of Technology<br/>
                                Email: kyokok@ait.ac.th
                            </div>
                        </Col>
                         <Col md="6" xs="12">
                            <div style={{fontSize: 18, textAlign: 'left', wordSpacing: 3, padding: 15, color: 'black', boxShadow: '0px 0px 6px #000', borderRadius:15, justifyContent:"center", marginBottom:20}}>
                                <a style={{fontWeight:"bold"}}>Prof Ruth Fitzgerald</a><br/>
                                Professor in Social Anthropology<br/>
                                Social Anthropology Program<br/>
                                School of Social Sciences<br/>
                                Otago University, New Zealand<br/>
                                Email: ruth.fitzgerald@otago.ac.nz
                            </div>
                        </Col>
                        <Col md="6" xs="12">
                            <div style={{fontSize: 18, textAlign: 'left', wordSpacing: 3, padding: 15, color: 'black', boxShadow: '0px 0px 6px #000', borderRadius:15, justifyContent:"center", marginBottom:20}}>
                                <a style={{fontWeight:"bold"}}>Prof. Ishtiaq Jamil</a><br/>
                                Professor in Public Administration<br/>
                                Department of Government<br/>
                                University of Bergen<br/>
                                Bergen, Norway<br/>
                                Email: Ishtiaq.Jamil@uib.no
                            </div>
                        </Col>
                        
                        <Col md="6" xs="12">
                            <div style={{fontSize: 18, textAlign: 'left', wordSpacing: 3, padding: 15, color: 'black', boxShadow: '0px 0px 6px #000', borderRadius:15, justifyContent:"center", marginBottom:20}}>
                                <a style={{fontWeight:"bold"}}>Dr. Sasanka Perera</a><br/>
                                Former Professor <br/>
                                Department of Sociology<br/>
                                South Asian University<br/>
                                Akbar Bhawan, Chankyapuri<br/>
                                New Delhi -110021<br/>
                                Email: sasankaperera@soc.sau.ac.in
                            </div>
                        </Col>
                        <Col md="6" xs="12">
                            <div style={{fontSize: 18, textAlign: 'left', wordSpacing: 3, padding: 15, color: 'black', boxShadow: '0px 0px 6px #000', borderRadius:15, justifyContent:"center", marginBottom:20}}>
                                <a style={{fontWeight:"bold"}}>Dr. DB Subedi</a><br/>
                                Senior Lecturer in Peace and Conflict Studies <br/>
                                Convenor of Peace and Conflict Studies <br/>
                                School of Political Science and International Studies <br/>
                                The University of Queensland<br/>
                                Brisbane Qld 4072, Australia<br/>
                                Email: d.subedi@uq.edu.au
                            </div>
                        </Col>
                    </Row>

                    <Row
                        data-aos="fade-up"
                        data-aos-offset="100"
                    >
                        <div style={{fontWeight:"bold", fontSize:22, display:"flex", justifyContent:"center", marginTop:20, marginBottom:20}}>Language Editors</div><br/>
                    </Row>
                    <Row
                        data-aos="fade-up"
                        data-aos-offset="100"
                    >
                       
                        <Col md="6" xs="12">
                            <div style={{fontSize: 18, textAlign: 'left', wordSpacing: 3, padding: 15, color: 'black', boxShadow: '0px 0px 6px #000', borderRadius:15, justifyContent:"center", marginBottom:20}}>
                                <a style={{fontWeight:"bold"}}>Ms. SPSP Weerasinghe</a><br/>
                                Senior Lecturer<br/>
                                Department of Social Sciences<br/>
                                Faculty of Social Sciences and Languages<br/>
                                Sabaragamuwa University of Sri Lanka<br/>
                                Email: sajani@ssl.sab.ac.lk
                            </div>
                        </Col>
                        <Col md="6" xs="12">
                            <div style={{fontSize: 18, textAlign: 'left', wordSpacing: 3, padding: 15, color: 'black', boxShadow: '0px 0px 6px #000', borderRadius:15, justifyContent:"center", marginBottom:20}}>
                                <a style={{fontWeight:"bold"}}>Mr. WMPYB Rathnayaka</a><br/>
                                Senior Lecturer<br/>
                                Department of Languages<br/>
                                University of Moratuwa<br/>
                                Email: 
                            </div>
                        </Col>
                         <Col md="6" xs="12">
                            <div style={{fontSize: 18, textAlign: 'left', wordSpacing: 3, padding: 15, color: 'black', boxShadow: '0px 0px 6px #000', borderRadius:15, justifyContent:"center", marginBottom:20}}>
                                <a style={{fontWeight:"bold"}}>Mrs. AD Maxworth</a><br/>
                                Senior Lecturer<br/>
                                Department of English Language Teaching<br/>
                                Faculty of Social Sciences and Languages<br/>
                                Sabaragamuwa University of Sri Lanka<br/>
                                Email: maxworth@ssl.sab.ac.lk
                            </div>
                        </Col>
                           <Col md="6" xs="12">
                            <div style={{fontSize: 18, textAlign: 'left', wordSpacing: 3, padding: 15, color: 'black', boxShadow: '0px 0px 6px #000', borderRadius:15, justifyContent:"center", marginBottom:20}}>
                                <a style={{fontWeight:"bold"}}>Ms. NALDR Silva</a><br/>
                                Senior Lecturer<br/>
                                Department of English Language Teaching<br/>
                                Faculty of Social Sciences and Languages<br/>
                                Sabaragamuwa University of Sri Lanka<br/>
                                Email: dilusha@ssl.sab.ac.lk
                            </div>
                        </Col>
                    </Row>

                    <Row
                        data-aos="fade-up"
                        data-aos-offset="100"
                    >
                        <div style={{fontWeight:"bold", fontSize:22, display:"flex", justifyContent:"center", marginTop:20, marginBottom:20}}>Editorial Assistance</div><br/>
                    </Row>
                    <Row
                        data-aos="fade-up"
                        data-aos-offset="100"
                    >
                        <Col md="6" xs="12">
                            <div style={{fontSize: 18, textAlign: 'left', wordSpacing: 3, padding: 15, color: 'black', boxShadow: '0px 0px 6px #000', borderRadius:15, justifyContent:"center", marginBottom:20}}>
                                <a style={{fontWeight:"bold"}}>Ms. Anudika Wickramasinghe</a><br/>
                                Lecturer<br/>
                                Department of Social Sciences<br/>
                                Rajarata University of Sri Lanka<br/>
                                Email: anudikaw@gmail.com<br/><br/>
                            </div>
                        </Col>
                        <Col md="6" xs="12">
                            <div style={{fontSize: 18, textAlign: 'left', wordSpacing: 3, padding: 15, color: 'black', boxShadow: '0px 0px 6px #000', borderRadius:15, justifyContent:"center", marginBottom:20}}>
                                <a style={{fontWeight:"bold"}}>Mr. AS Dilan Gomas</a><br/>
                                Demostrator<br/>
                                Department of Information Technology<br/>
                                Faculty of Social Sciences and Languages<br/>
                                Sabaragamuwa University of Sri Lanka<br/>
                                Email: as_dilan@ssl.sab.ac.lk
                            </div>
                        </Col>
                    </Row>

                </Container>
            </div>


            <Footer/>

        </div>
    );
}

export default boardOfEditorsView;
